import { render, staticRenderFns } from "./SettingAdminContext.vue?vue&type=template&id=a268a04c&scoped=true&"
import script from "./SettingAdminContext.vue?vue&type=script&lang=js&"
export * from "./SettingAdminContext.vue?vue&type=script&lang=js&"
import style0 from "./SettingAdminContext.vue?vue&type=style&index=0&id=a268a04c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a268a04c",
  null
  
)

export default component.exports